import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold tracking-[-0.01em] transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/70 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-white/10 bg-[linear-gradient(135deg,#172554_0%,#1e3a8a_48%,#312e81_100%)] text-white shadow-[0_14px_35px_rgba(15,23,42,0.24)] hover:-translate-y-0.5 hover:shadow-[0_18px_44px_rgba(15,23,42,0.30)] hover:brightness-110",
        destructive:
          "bg-red-500 text-white shadow-[0_12px_30px_rgba(239,68,68,0.22)] hover:-translate-y-0.5 hover:bg-red-600",
        outline:
          "border border-slate-200/80 bg-white/80 text-slate-900 shadow-[0_10px_28px_rgba(15,23,42,0.06)] backdrop-blur hover:-translate-y-0.5 hover:border-violet-200 hover:bg-violet-50/80 hover:text-violet-800",
        secondary:
          "border border-slate-200/80 bg-slate-100/80 text-slate-900 shadow-sm backdrop-blur hover:-translate-y-0.5 hover:bg-white",
        ghost: "text-slate-700 hover:bg-white/75 hover:text-slate-950",
        link: "text-indigo-700 underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 px-3 text-xs",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)
const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
